import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons/faInfoCircle';

import { Tooltip } from 'ui-components/components/tooltip';
import { testId } from 'ui-components/services/testid-service';

import { CustomsField } from '../customs-field';
import { CustomsTextInput } from '../customs-text-input';
import { messages } from '../messages';
import commonStyle from '../common-style.module.less';

type CustomsMpidProps = {
  onChange: (newValue: string | number) => void;
  value?: string;
};

export const CustomsMpid = ({ onChange, value = '' }: CustomsMpidProps) => {
  const intl = useIntl();

  const tooltip = (
    <Tooltip position='top' text={intl.formatMessage(messages.nsManufacturerProductIdTooltip)}>
      <FontAwesomeIcon icon={faInfoCircle} />
    </Tooltip>
  );

  return (
    <CustomsField
      label={messages.nsManufacturerProductIdLabel}
      labelClassname={commonStyle['label-with-tooltip']}
      recommended
      tooltip={tooltip}
    >
      <CustomsTextInput
        {...testId('customs-widget-ns-manufacturer-product-id-input')}
        aria-label={intl.formatMessage(messages.nsManufacturerProductIdLabel)}
        onChange={onChange}
        type='text'
        value={value}
      />
    </CustomsField>
  );
};
